import { alpha } from '@mui/material';
import basicTheme from '../basicTheme.js';
import typography from '../typography.js';

const menuItemStyleOverrides = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: Object.assign(Object.assign({ display: 'flex', alignItems: 'center', width: '160px', minHeight: '20px', height: '36px', padding: basicTheme.spacing(2.5, 3, 2.5, 3) }, typography.subtitle2), { 'svg:first-of-type': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: basicTheme.spacing(2, 2, 2, 0),
            }, '&:hover': {
                color: basicTheme.palette.N05.main,
                backgroundColor: basicTheme.palette.N30.main,
            }, '&.Mui-disabled': {
                pointerEvents: 'auto',
                cursor: 'not-allowed',
                opacity: 1,
                color: alpha(basicTheme.palette.N20.main, 0.4),
                '&:hover': {
                    color: alpha(basicTheme.palette.N20.main, 0.4),
                    backgroundColor: basicTheme.palette.N40.main,
                },
            } }),
        dense: Object.assign(Object.assign({}, typography.body1), { textTransform: 'none', width: '128px', height: '20px', padding: basicTheme.spacing(0, 0, 0, 3), svg: {
                margin: basicTheme.spacing(2, 1, 2, 0),
            } }),
    },
};

export { menuItemStyleOverrides as default };
//# sourceMappingURL=MuiMenuItem.js.map
